<template>
  <div class="indicator-tree-modal">
    <div class="search-wrapper mb-3">
      <b-form-input
        v-model="searchText"
        :placeholder="$t('pesquisar-indicador')"
        class="input-pentagro"
        autofocus
      />
    </div>

    <div class="indicator-list">
      <div
        v-for="item in filteredIndicators"
        :key="`${item.id}-${item.productionUnitId}-${item.system}`"
        class="indicator-item"
        :class="{ 'indicator-item--selected': isSelected(item) }"
        :style="{ paddingLeft: `${(item.treeLevel || 0) * 16 + 8}px` }"
        @click="selectIndicator(item)"
      >
        <span class="indicator-level-dot" v-if="item.treeLevel > 0">—</span>
        {{ item.indicatorName }}
      </div>
      <div v-if="filteredIndicators.length === 0" class="text-muted p-2">
        {{ $t('nenhum-indicador-encontrado') }}
      </div>
    </div>

    <div class="modal-footer-actions mt-3">
      <button
        class="confirm-btn mr-2"
        :disabled="!selectedItem"
        @click="confirm"
      >
        {{ $t('confirmar') }}
      </button>
      <button class="cancel-btn" @click="$emit('cancel')">
        {{ $t('cancelar') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndicatorTreeModal',

  props: {
    indicators: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      searchText: '',
      selectedItem: null
    }
  },

  computed: {
    filteredIndicators() {
      if (!this.searchText.trim()) return this.indicators
      const term = this.searchText.toLowerCase()
      return this.indicators.filter(i =>
        i.indicatorName && i.indicatorName.toLowerCase().includes(term)
      )
    }
  },

  methods: {
    selectIndicator(item) {
      this.selectedItem = item
    },

    isSelected(item) {
      return this.selectedItem &&
        this.selectedItem.indicatorId === item.indicatorId &&
        this.selectedItem.productionUnitId === item.productionUnitId &&
        this.selectedItem.system === item.system
    },

    confirm() {
      if (!this.selectedItem) return
      this.$emit('select', {
        indicatorId: this.selectedItem.indicatorId,
        indicatorName: this.selectedItem.indicatorName,
        productionUnitId: this.selectedItem.productionUnitId,
        system: this.selectedItem.system
      })
    }
  }
}
</script>

<style scoped>
.indicator-tree-modal {
  max-height: 500px;
  display: flex;
  flex-direction: column;
}

.indicator-list {
  overflow-y: auto;
  max-height: 380px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.indicator-item {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.9rem;
  transition: background-color 0.15s;
}

.indicator-item:hover {
  background-color: #f8f9fa;
}

.indicator-item--selected {
  background-color: #e8f4fd;
  font-weight: 600;
  color: #0056b3;
}

.indicator-level-dot {
  color: #aaa;
  margin-right: 4px;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
}

.confirm-btn {
  background: #f07000;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.confirm-btn:hover:not(:disabled) {
  background: #d06000;
}

.confirm-btn:disabled {
  background: #f0a060;
  cursor: not-allowed;
}

.cancel-btn {
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #5a6268;
}
</style>
